import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

/**
 * Public Booking Link Handler
 * 
 * This page handles public booking links like:
 * https://hairchitech.com/book/KWVIt4UD1m5o
 * 
 * It stores the publicBookingId and redirects to the booking portal
 * which now supports public (unauthenticated) bookings.
 */
export default function PublicBookingLinkPage() {
  const { slug } = useParams(); // This is actually the publicBookingId
  const navigate = useNavigate();

  useEffect(() => {
    if (slug) {
      // Store the public booking ID for the booking flow
      localStorage.setItem('public_booking_id', slug);
      
      // Redirect directly to the booking portal
      // The booking portal will detect the publicBookingId and work in public mode
      navigate('/app/book', { replace: true });
    } else {
      // No publicBookingId provided, redirect to home
      navigate('/', { replace: true });
    }
  }, [slug, navigate]);

  // Show a loading state while redirecting
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 via-black to-gray-800">
      <div className="text-white text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-white mx-auto mb-4"></div>
        <p>Loading booking page...</p>
      </div>
    </div>
  );
}
